import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import toast from "react-hot-toast";
import { V_URL } from "../../../../../BaseUrl";
import axios from "axios";
import PurchaseOrderFields from "./components/PurchaseOrderFields";
import PurPoItems from "./components/PurPoItems";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getViewPoItems } from "../../../../../Store/prosafe/proTransaction/PurOrder/getViewPoItems";
import { getStorePayment } from "../../../../../Store/Store/StoreMaster/PaymentMethod/getPaymentList";
import { getQuotation } from "../../../../../Store/Store/StoreMaster/Quotation/getQuotationList";
import { addParty } from "../../../../../Store/Store/Party/ManageParty";
import { getPartyGroup } from "../../../../../Store/Store/StoreMaster/PartyGroup/PartyGroup";
import { getPartyTag } from "../../../../../Store/Store/StoreMaster/PartyTag/PartyTag";
import PartyModal from "../../../../../Components/Party/PartyModal";
import TaxSummary from "../../../../../Components/Transaction/TaxSummary";
import { getStoreQuotationDropdown } from "../../../../../Store/Store/StoreMaster/StoreQuotation/getStoreQuotation";
import { STORE_QUOTATION_STATUS } from "../../../../../helper/storeQuotation";

const DEFAULT_PO_TERMS = `1. Materials should be Supplied for the Specifications and Quality standards.<br />2. Delivery Within The Distribution Time is Mandatory.<br />3. Any Defect of Materials Will be returned.<br />4. Supplier Must Submit a Proper Tax Invoice With GST Details.<br />5. Po Number Must be Mentioned on All Invoices and Delivery Challan. <br />
<br />Thanks for doing business with us.<br />
`;

const ManagePurOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState({
    trans_date: moment(Date.now()).format("YYYY-MM-DD"),
    master_id: "",
    party_id: "",
    project_id: "",
    manual_pro_no: "",
    payment_method_id: "",
    quotation_id: "",
    store_quotation_id: "",
    freight_amount: "",
    remarks: ""
  });
  const [itemsArr, setItemsArr] = useState([]);
  const [termsCondition, setTermsCondition] = useState(DEFAULT_PO_TERMS || "");

  const initialPartyState = { name: "", phone: "", address: "", pincode: "", group: "", party_tag: "" };
  const [partyModal, setPartyModal] = useState(false);
  const [partyForm, setPartyForm] = useState(initialPartyState);
  const [partyState, setPartyState] = useState("");
  const [partyCity, setPartyCity] = useState("");
  const [partyError, setPartyError] = useState({});
  const [partyDisable, setPartyDisable] = useState(false);

  const tagData = useSelector((state) => state?.getPartyTag?.user?.data) || [];

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 10 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getStorePayment({ status: "true" }));
    dispatch(getQuotation());
    dispatch(getPartyGroup());
    dispatch(getPartyTag());
    dispatch(getStoreQuotationDropdown({
      status: data?._id
        ? [STORE_QUOTATION_STATUS.FINALIZED, STORE_QUOTATION_STATUS.ORDERED]
        : [STORE_QUOTATION_STATUS.FINALIZED],
    }));
  }, []);

  useEffect(() => {
    if (tagData?.length > 0 && !partyForm.party_tag) {
      const partyTag = tagData.find((tag) => tag.name?.toLowerCase() === "party");
      if (partyTag) {
        setPartyForm((prev) => ({ ...prev, party_tag: partyTag._id }));
      }
    }
  }, [tagData]);

  const itemData = useSelector((state) => state?.getViewPoItems?.user?.data);

  useEffect(() => {
    if (data?._id) {
      dispatch(getViewPoItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        master_id: data?.create_by?._id,
        project_id: data?.project_details?._id,
        manual_pro_no: data?.manual_pro_no,
        party_id: data?.party_details?._id,
        payment_method_id: data?.payment_method_id,
        quotation_id: data?.quotation_details?._id,
        store_quotation_id: data?.store_quotation_details?._id,
        freight_amount: data?.freight_amount,
        remarks: data?.remarks,
      });
    } else {
      setForm({
        trans_date: moment(Date.now()).format("YYYY-MM-DD"),
        master_id: "",
        party_id: "",
        project_id: "",
        manual_pro_no: "",
        payment_method_id: "",
        quotation_id: "",
        store_quotation_id: "",
        freight_amount: "",
        remarks: "",
      });
      setItemsArr([]);
      setError({});
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details);
      } else {
        setItemsArr([]);
      }
    } else {
      setItemsArr([]);
    }
  }, [itemData, data]);

  useEffect(() => {
    if (data?._id) {
      setTermsCondition(data?.termsCondition);
    }
  }, [data]);

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Order",
      link: "/main-store/user/purchase-order-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Order", active: true },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handleSubmit = () => {
    if (!validateForm()) {
      return;
    }
    if (!validateItems()) return;

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-add-one-po`;

    const payload = {
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      tag_number: 10,
      trans_date: form.trans_date,
      master_id: form.master_id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      party_id: form.party_id,
      freight_amount: form.freight_amount,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      store_quotation_id: form.store_quotation_id ? form.store_quotation_id : null,
      payment_method_id: form.payment_method_id,
      items_details: JSON.stringify(itemsArr),
      termsCondition: termsCondition,
      remarks: form.remarks,
    };

    axios({
      method: "post",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-order-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleUpdate = () => {
    if (!validateForm()) {
      return;
    }

    if (!validateItems()) return;

    setDisable(true);
    const myurl = `${V_URL}/prosafe/pro-update-po`;

    const payload = {
      trans_date: form.trans_date,
      id: data?._id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,
      master_id: form.master_id,
      party_id: form.party_id,
      freight_amount: form.freight_amount,
      quotation_id: form.quotation_id ? form.quotation_id : null,
      store_quotation_id: form.store_quotation_id ? form.store_quotation_id : null,
      payment_method_id: form.payment_method_id,
      termsCondition: termsCondition,
      remarks: form.remarks,
    };

    axios({
      method: "put",
      url: myurl,
      data: payload,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-order-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const validateItems = () => {
    if (!itemsArr || itemsArr.length === 0) {
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const isQuillBlank = (value) => {
    const text = value.replace(/<[^>]+>/g, "").trim();
    return text.length === 0;
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    if (!form.master_id) {
      newErrors.master_id = "Requested by is required";
      isValid = false;
    }
    if (!form.project_id) {
      newErrors.project_id_err = "Project is required";
      isValid = false;
    }
    if (!form.party_id) {
      newErrors.party_id_err = "Party is required";
      isValid = false;
    }
    if (!form.payment_method_id) {
      newErrors.payment_err = "Payment Method is required";
      isValid = false;
    }

    if (isQuillBlank(termsCondition)) {
      newErrors.terms_err = "Terms and Conditions can't be empty";
      isValid = false;
    }

    setError(newErrors);
    return isValid;
  };

  const handlePartyModalSubmit = () => {
    const newErrors = {};
    if (!partyForm.name.trim()) newErrors.name_err = "Please enter name";
    if (!partyForm.phone) newErrors.phone_err = "Please enter mobile";
    else if (!/^\d{10}$/.test(partyForm.phone)) newErrors.phone_err = "Please enter a valid mobile";
    if (!partyForm.address.trim()) newErrors.address_err = "Please enter address";
    if (!partyState) newErrors.state_err = "Please select state";
    if (!partyCity) newErrors.city_err = "Please select city";
    if (!partyForm.pincode) newErrors.pincode_err = "Please enter pincode";
    if (!partyForm.group) newErrors.group_err = "Please select group";
    if (!partyForm.party_tag) newErrors.party_tag_err = "Please select tag";

    if (Object.keys(newErrors).length > 0) {
      setPartyError(newErrors);
      return;
    }

    setPartyDisable(true);
    const formData = new URLSearchParams();
    formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
    formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
    formData.append("name", partyForm.name);
    formData.append("phone", partyForm.phone);
    formData.append("address", partyForm.address);
    formData.append("state", partyState);
    formData.append("city", partyCity);
    formData.append("pincode", partyForm.pincode);
    formData.append("partyGroup", partyForm.group);
    formData.append("party_tag_id", partyForm.party_tag);
    formData.append("store_type", "1");

    dispatch(addParty(formData))
      .then((res) => {
        if (res?.payload?.success === true) {
          dispatch(getParty({ is_main: true }));
          setPartyModal(false);
          setPartyForm(initialPartyState);
          setPartyState("");
          setPartyCity("");
          setPartyError({});
        }
      })
      .catch(() => { })
      .finally(() => setPartyDisable(false));
  };

  const handleReset = () => {
    setForm({
      trans_date: "",
      master_id: "",
      party_id: "",
      project_id: "",
      store_quotation_id: "",
    });
    setError({});
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const totals = React.useMemo(() => {
    return itemsArr?.reduce(
      (acc, item) => {
        acc.quantity += Number(item.quantity) || 0;
        acc.amount += Number(item.amount) || 0;
        acc.total_amount += Number(item.total_amount) || 0;
        acc.rate += Number(item.rate) || 0;
        acc.discount_amount += Number(item.discount_amount) || 0;
        acc.taxable_amount += Number(item.taxable_amount) || 0;
        acc.gst_amount += Number(item.gst_amount) || 0;
        return acc;
      },
      {
        quantity: 0,
        amount: 0,
        total_amount: 0,
        rate: 0,
        discount_amount: 0,
        taxable_amount: 0,
        gst_amount: 0,
      }
    );
  }, [itemsArr]);

  const freightAmount = parseFloat(form?.freight_amount) || 0;
  const freightWithGst = freightAmount * 1.18;

  const totalBeforeRound = (totals?.taxable_amount || 0) + (totals?.gst_amount || 0) + freightWithGst;
  const roundOff = Math.round(totalBeforeRound) - totalBeforeRound;
  const total = Math.round(totalBeforeRound);

  const taxSummary = {
    grossAmount: totals?.amount || 0,
    discountAmount: totals?.discount_amount || 0,
    taxableAmount: totals?.taxable_amount || 0,
    subtotal: totals?.amount || 0,
    cgst: 0,
    sgst: 0,
    igst: totals?.gst_amount || 0,
    taxAmount: totals?.gst_amount || 0,
    roundOff,
    total,
    freight_amount: freightAmount,
  };

  const handleTermsChange = (e, name, value) => {
    setTermsCondition(value);
    if (error.terms_err) {
      setError((prev) => {
        const newErr = { ...prev };
        delete newErr.terms_err;
        return newErr;
      });
    }
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Order Details
                        </h4>
                      </div>
                    </div>
                    <PurchaseOrderFields
                      form={form}
                      handleChange={handleChange}
                      error={error}
                      data={data}
                      onAddParty={() => setPartyModal(true)}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          <PurPoItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            data={data}
            form={form}
          />

          {/* Terms and condition section  */}
          <div className="row px-3 py-0">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <TaxSummary
                    data={{ ...form, termsCondition, total_quantity: totals?.quantity || 0 }}
                    handleChange={handleTermsChange}
                    taxSummary={taxSummary}
                    taxType="igst"
                    showTerms={true}
                    termsFieldName="termsCondition"
                    isReceiveLoading={false}
                  />
                  {error.terms_err && (
                    <div className="text-danger small mt-2">{error.terms_err}</div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={data?._id ? handleUpdate : handleSubmit}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                            ? "Update"
                            : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <PartyModal
        show={partyModal}
        onClose={() => {
          setPartyModal(false);
          setPartyForm(initialPartyState);
          setPartyState("");
          setPartyCity("");
          setPartyError({});
        }}
        party={partyForm}
        setParty={(field, value) => setPartyForm((p) => ({ ...p, [field]: value }))}
        selectedState={partyState}
        setSelectedState={setPartyState}
        selectedCity={partyCity}
        setSelectedCity={setPartyCity}
        error={partyError}
        onSubmit={handlePartyModalSubmit}
        disableSubmit={partyDisable}
      />
    </div>
  );
};

export default ManagePurOrder;
